document.addEventListener("DOMContentLoaded", () => {
  // Select all input elements within .form-field.newsletter-input
  const inputs = document.querySelectorAll(
    ".form-field.newsletter-input .form-field-input"
  );

  inputs.forEach((input) => {
    // Function to toggle 'hidden' class on the label
    const toggleHiddenClass = () => {
      const siblingLabel =
        input.parentElement.querySelector(".form-field-title");
      if (input.value.trim() !== "") {
        siblingLabel?.classList.add("hidden");
      } else {
        siblingLabel?.classList.remove("hidden");
      }
    };

    // Listen for input event to detect typing
    input.addEventListener("input", toggleHiddenClass);

    // Initial check in case the input already has a value
    toggleHiddenClass();
  });
});


/* Header Highlights */
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(
    "#header-highlights .highlight-single"
  );
  let currentIndex = 0;

  const updateSlides = () => {
    items.forEach((item, index) => {
      item.classList.remove("active");
      if (index === currentIndex) {
        item.classList.add("active");
      }
    });
  };

  const nextSlide = () => {
    currentIndex = (currentIndex + 1) % items.length;
    updateSlides();
  };

  updateSlides();

  setInterval(nextSlide, 1500);
});


/* Blog Posts Section - Flickity */
document.addEventListener("DOMContentLoaded", function () {
  const blogPostsContainer = document.querySelector(".blogposts--inner");

  if (!blogPostsContainer) {
    console.warn("Blog posts container not found.");
    return;
  }

  let flickityInstance = null;

  // Function to initialize Flickity
  const initializeFlickity = () => {
    if (flickityInstance) return; // Prevent re-initialization

    flickityInstance = new Flickity(blogPostsContainer, {
      cellSelector: ".article--excerpt-wrapper",
      groupCells: 1,
      wrapAround: true,
      pageDots: true,
      contain: true,
      autoPlay: 5000,
      accessibility: true,
      arrowShape:
        "M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z",
    });

    console.log("Flickity initialized for mobile/tablet.");
  };

  // Function to destroy Flickity
  const destroyFlickity = () => {
    if (flickityInstance) {
      flickityInstance.destroy();
      flickityInstance = null;
      console.log("Flickity destroyed.");
    }
  };

  // Function to check screen size and toggle Flickity
  const handleScreenSize = () => {
    const isMobileOrTablet = window.innerWidth < 1024;

    if (isMobileOrTablet) {
      initializeFlickity();
    } else {
      destroyFlickity();
    }
  };

  // Run on page load
  handleScreenSize();

  // Run on window resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleScreenSize, 300); // Debounce resize
  });
});


/* Faceted Filters */
document.addEventListener("DOMContentLoaded", function () {
  console.log("Price range slider script loaded");

  const sliderContainer = document.querySelector("[data-filter-group-range]");
  const inputMin = document.querySelector("input[name='filter.v.price.gte']");
  const inputMax = document.querySelector("input[name='filter.v.price.lte']");

  if (!sliderContainer || !inputMin || !inputMax) {
    console.error("Required elements for the range slider are missing.");
    return;
  }

  // Get min and max values from inputs
  const minValue = parseFloat(inputMin.min) || 0;
  const maxValue = parseFloat(inputMax.max) || 10000;
  const currentMin = parseFloat(inputMin.value) || minValue;
  const currentMax = parseFloat(inputMax.value) || maxValue;

  // Create a container for the slider
  const slider = document.createElement("div");
  slider.id = "price-range-slider";
  sliderContainer.insertBefore(slider, sliderContainer.firstChild);

  // Initialize noUiSlider
  noUiSlider.create(slider, {
    start: [currentMin, currentMax],
    connect: true,
    range: {
      min: minValue,
      max: maxValue,
    },
    step: 10,
    tooltips: [
      {
        to: (value) => `$${parseFloat(value).toFixed(2)}`,
        from: (value) => parseFloat(value),
      },
      {
        to: (value) => `$${parseFloat(value).toFixed(2)}`,
        from: (value) => parseFloat(value),
      },
    ],
    format: {
      to: (value) => value.toFixed(2),
      from: (value) => parseFloat(value),
    },
  });

  // Sync slider with inputs
  slider.noUiSlider.on("update", function (values) {
    inputMin.value = values[0];
    inputMax.value = values[1];
  });

  // Sync inputs with slider when manually updated
  inputMin.addEventListener("change", function () {
    slider.noUiSlider.set([this.value, null]);
  });

  inputMax.addEventListener("change", function () {
    slider.noUiSlider.set([null, this.value]);
  });

  // Trigger form submission when slider values change
  slider.noUiSlider.on("change", function () {
    console.log("Slider values changed: ", inputMin.value, inputMax.value);
    inputMin.dispatchEvent(new Event("change", { bubbles: true }));
    inputMax.dispatchEvent(new Event("change", { bubbles: true }));
  });
});


/* Collection Bottom Description */

document.addEventListener("DOMContentLoaded", () => {
  // Select all sections with the rich-text class
  const sections = document.querySelectorAll(
    "section.collection-bottom-description"
  );

  sections.forEach((section) => {
    // Find the container where the h3 and other elements are located
    const richTextContent = section.querySelector(".rich-text-content.rte");

    if (richTextContent) {
      // Query all h3 elements within this container
      const h3Elements = richTextContent.querySelectorAll("h3");

      h3Elements.forEach((h3) => {
        const wrapper = document.createElement("div");
        wrapper.className = "desc-block";

        // Append the current h3 to the wrapper
        wrapper.appendChild(h3.cloneNode(true));

        let nextElement = h3.nextElementSibling;

        // Collect all sibling elements until the next h3 or h2
        while (
          nextElement &&
          !["H3", "H2"].includes(nextElement.tagName.toUpperCase())
        ) {
          wrapper.appendChild(nextElement.cloneNode(true));
          const temp = nextElement.nextElementSibling; // Store reference to the next element
          nextElement.remove(); // Remove the element after cloning
          nextElement = temp; // Update to the next sibling
        }

        // Replace the original h3 with the wrapper
        h3.replaceWith(wrapper);
      });
    }
  });
})

/* Collection FAQs */

document.addEventListener("DOMContentLoaded", () => {
  // Select all sections with the collection-faqs class
  const faqSections = document.querySelectorAll("section.collection-faqs");

  faqSections.forEach((section) => {
    // Find the container where the h3 and other elements are located
    const richTextContent = section.querySelector(".rich-text-content.rte");

    if (richTextContent) {
      // Query all h3 elements within this container
      const h3Elements = richTextContent.querySelectorAll("h3");

      h3Elements.forEach((h3) => {
        const wrapper = document.createElement("div");
        wrapper.className = "faq-single";

        // Append the current h3 to the wrapper
        wrapper.appendChild(h3.cloneNode(true));

        let nextElement = h3.nextElementSibling;

        // Collect all sibling elements until the next h3 or h2
        while (
          nextElement &&
          !["H3", "H2"].includes(nextElement.tagName.toUpperCase())
        ) {
          wrapper.appendChild(nextElement.cloneNode(true));
          const temp = nextElement.nextElementSibling; // Store reference to the next element
          nextElement.remove(); // Remove the element after cloning
          nextElement = temp; // Update to the next sibling
        }

        // Replace the original h3 with the wrapper
        h3.replaceWith(wrapper);
      });
    }
  });
});


/* Blogs */

